// src/services/portfolioService.js - SECURED
import { API_BASE_URL } from '../utils/constants';

const getAuthHeaders = () => {
  return {
    'Content-Type': 'application/json',
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    if (response.status === 401) {
      window.location.href = '/';
    }
    const error = await response.json();
    throw new Error(error.error || error.detail || 'Request failed');
  }
  return response.json();
};

export const portfolioService = {
  /**
   * Get recent transactions (deposits, withdrawals, trades)
   * @param {number} limit - Number of transactions to fetch
   */
  async getRecentTransactions(limit = 10) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/transactions/recent/?limit=${limit}`,
        {
          method: 'GET',
          headers: getAuthHeaders(),
          credentials: 'include',
        }
      );
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching recent transactions:', error);
      throw error;
    }
  },

  /**
   * Get recent deposits only
   * @param {number} limit - Number of deposits to fetch
   */
  async getRecentDeposits(limit = 3) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/transactions/history/?type=deposit&page_size=${limit}`,
        {
          method: 'GET',
          headers: getAuthHeaders(),
          credentials: 'include',
        }
      );
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching recent deposits:', error);
      throw error;
    }
  },

  /**
   * Get recent withdrawals only
   * @param {number} limit - Number of withdrawals to fetch
   */
  async getRecentWithdrawals(limit = 3) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/transactions/history/?type=withdrawal&page_size=${limit}`,
        {
          method: 'GET',
          headers: getAuthHeaders(),
          credentials: 'include',
        }
      );
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching recent withdrawals:', error);
      throw error;
    }
  },

  /**
   * Get user's referral code and stats
   */
  async getReferralInfo() {
    try {
      const response = await fetch(
        `${API_BASE_URL}/referral/link/`,
        {
          method: 'GET',
          headers: getAuthHeaders(),
          credentials: 'include',
        }
      );
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching referral info:', error);
      throw error;
    }
  },

  /**
   * Get user's referral bonus summary
   */
  async getReferralBonusSummary() {
    try {
      const response = await fetch(
        `${API_BASE_URL}/referral/bonuses/summary/`,
        {
          method: 'GET',
          headers: getAuthHeaders(),
          credentials: 'include',
        }
      );
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching referral bonus summary:', error);
      throw error;
    }
  },

  /**
   * Get user's referral wallet
   */
  async getReferralWallet() {
    try {
      const response = await fetch(
        `${API_BASE_URL}/referral/wallet/`,
        {
          method: 'GET',
          headers: getAuthHeaders(),
          credentials: 'include',
        }
      );
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching referral wallet:', error);
      throw error;
    }
  },

  /**
   * Get portfolio summary (total balance, investments, etc.)
   */
  async getPortfolioSummary() {
    try {
      const response = await fetch(
        `${API_BASE_URL}/transactions/summary/`,
        {
          method: 'GET',
          headers: getAuthHeaders(),
          credentials: 'include',
        }
      );
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching portfolio summary:', error);
      throw error;
    }
  },

  /**
   * Get user's wallet balance
   */
  async getWalletBalance() {
    try {
      const response = await fetch(
        `${API_BASE_URL}/deposit/wallet/`,
        {
          method: 'GET',
          headers: getAuthHeaders(),
          credentials: 'include',
        }
      );
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching wallet balance:', error);
      throw error;
    }
  }
};